import { LicenseSelectorsNames } from "store/entities/license";
import { createRequestFetchingSelector } from "store/requests/selectors";

export const selectIsForwardingInstructionsSending = createRequestFetchingSelector([
  LicenseSelectorsNames.SEND_FORWARDING_INSTRUCTIONS,
]);
